// #105 (S1, plan D7): the embedding mode of the portal, independent of the QR
// session state. Embedded = rendered in an iframe (storefront app block); the
// iframe grows with the content (IFrameResizer), so the action bar sits at the
// end of the content. Top level = the page itself scrolls (QR entry, status
// link opened full screen) and the bar is sticky. A cross-origin parent that
// throws on access counts as embedded.
export const isEmbedded = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};
